import { Link } from 'react-router-dom';

const SECURITY_ITEMS = [
  { icon: 'ri-shield-check-line', title: '会社ごとの完全データ分離', description: 'テナントごとにデータを分離し、他社の情報にアクセスできない設計です。' },
  { icon: 'ri-cloud-line', title: 'Google Cloud東京リージョン', description: 'データはGoogle Cloudの東京リージョンで管理しています。' },
  { icon: 'ri-refresh-line', title: '毎日自動バックアップ', description: 'データは毎日自動でバックアップされ、障害時に復旧可能です。' },
  { icon: 'ri-file-search-line', title: '監査ログ', description: '誰がいつどの操作を行ったかを記録し、追跡可能です。' },
  { icon: 'ri-lock-line', title: '権限管理', description: 'メンバーごとに閲覧・編集権限を細かく設定できます。' },
  { icon: 'ri-shield-keyhole-line', title: '通信の暗号化', description: 'すべての通信は暗号化され、安全にデータを送受信します。' },
];

export default function SecuritySection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-4">
          企業のプロジェクト情報を安全に管理
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-12">
          ”おもいむすび”は、セキュリティを最優先に設計されています
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-[960px] mx-auto">
          {SECURITY_ITEMS.map((item) => (
            <div key={item.title} className="flex items-start gap-4 bg-background-100 rounded-lg p-5 border border-background-200/70">
              <div className="w-10 h-10 bg-accent-100 rounded-lg flex items-center justify-center shrink-0">
                <i className={`${item.icon} text-accent-600 text-lg`}></i>
              </div>
              <div>
                <h3 className="text-sm font-bold text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center mt-8">
          <Link to="/security/" className="text-sm text-primary-600 hover:text-primary-700 font-medium inline-flex items-center gap-1">
            セキュリティの詳細を見る <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}